import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useLabels, usePrefs } from 'wsm-common-data';
import { setClassNames } from '@ddc/classnames-js';
import VehicleCard from './VehicleCard';
import { UIContext } from '../contexts';
import { g } from '../global-constants';

const VehicleCards = ({ vehicles }) => {
	const { inputWidth } = useContext(UIContext);
	const { display } = usePrefs();
	const labels = useLabels();

	const singleColumnWidth = 600;
	// Panel mode always renders a single column regardless of the measured
	// input width (D9), so it must not lose its bottom padding here either --
	// this mirrors the exclusion ContentColumnizer already applies.
	const isDoubleColumn =
		display !== g.NAVIGATION_DRAWER && inputWidth > singleColumnWidth;
	if (vehicles?.length > 0) {
		let keyCount = 0;
		return (
			<div
				data-testid="sts-vehicle-cards"
				role="region"
				aria-labelledby="vehicle-cards-heading"
				className={`${isDoubleColumn ? '' : 'pb-5'}`}
			>
				<h3
					id="vehicle-cards-heading"
					className={setClassNames(['sr-only'])}
				>
					{labels.get('VEHICLE_SEARCH_RESULTS')}
				</h3>
				{vehicles.slice(0, 5).map((vehicle) => {
					const {
						path,
						images: [image1],
						title,
						price,
						odometer,
						condition,
						city,
						state
					} = vehicle;

					const titleString = Array.isArray(title)
						? title.join(' ')
						: title;

					const image = image1;
					const capitalizedCondition = condition.toUpperCase();
					keyCount += 1;
					return (
						<VehicleCard
							href={path || null}
							imageUrl={image?.url}
							key={keyCount}
							title={titleString}
							price={price || ''}
							odometer={odometer || ''}
							condition={capitalizedCondition}
							city={city || ''}
							state={state || ''}
						/>
					);
				})}
			</div>
		);
	}
	return null;
};

VehicleCards.propTypes = {
	vehicles: PropTypes.arrayOf(
		PropTypes.shape({
			path: PropTypes.string,
			title: PropTypes.arrayOf(PropTypes.string),
			images: PropTypes.arrayOf(PropTypes.shape({})),
			price: PropTypes.string,
			odometer: PropTypes.string,
			condition: PropTypes.string,
			city: PropTypes.string,
			state: PropTypes.string
		})
	)
};

export default VehicleCards;
